export const INSPIRATIONAL_QUOTES = [
  'Every healthy choice you make today strengthens tomorrow.',
  'Progress starts the moment you decide to show up.',
  'You are building a new story one brave step at a time.',
  'Consistency beats intensity when healing is the goal.',
  'Small wins are still wins, and they count.',
  'Your future grows from the habits you practice today.',
  'Hope gets louder every time you keep your promise to yourself.',
  'You are not behind; you are in training.',
  'Healing is a practice, not a perfect performance.',
  'The fact that you are here proves your strength.',
  'You don’t need a perfect day to make meaningful progress.',
  'Your effort today is an investment in your freedom.',
  'One grounded choice can change the direction of a day.',
  'Courage looks like showing up again.',
  'Your growth is happening even when it feels slow.',
  'Keep going; your consistency is rewriting your patterns.',
  'You are allowed to begin again as many times as needed.',
  'Steady steps create lasting transformation.',
  'Mental wellness is built in moments like this one.',
  'You are learning how to trust yourself again.',
  'Discipline is a form of self-respect.',
  'The next right action is enough for now.',
  'You are stronger than the urge and wiser than the impulse.',
  'Healing becomes real when repeated choices align with your values.',
  'Your determination is greater than your doubt.',
  'You are not your past; you are your present decisions.',
  'Show up first, confidence follows.',
  'You can do hard things one moment at a time.',
  'The life you want is built by the choices you repeat.',
  'Each check-in is proof that you are still in the fight.',
  'Today is another chance to practice who you want to become.',
  'Mental wellness is momentum plus patience.',
  'Your effort matters, even when no one sees it.',
  'You are building resilience with every mindful pause.',
  'Healing grows where honesty lives.',
  'You are becoming someone you can rely on.',
  'Your values are stronger than temporary discomfort.',
  'The strongest comeback is made of ordinary faithful days.',
  'You are not starting over; you are starting wiser.',
  'Every time you choose health, you reclaim your power.',
  'Your commitment today protects your peace tomorrow.',
  'You are creating safety through consistency.',
  'One better decision is still a breakthrough.',
  'Momentum is built in the moments you choose not to quit.',
  'You are capable of more than yesterday suggested.',
  'Your current effort is future evidence of your courage.',
  'You are worthy of the life you are working for.',
  'Growth often feels quiet before it feels obvious.',
  'You are proving to yourself that change is possible.',
  'Healthy routines create hopeful outcomes.',
  'Your practice is stronger than your excuses.',
  'You are allowed to celebrate every step forward.',
  'A calm choice now can rescue the rest of your day.',
  'You are building trust with yourself one promise at a time.',
  'The best time to reset is right now.',
  'Your next choice has the power to change your trajectory.',
  'You are not alone in this work, and you are not done.',
  'Every return is a victory over giving up.',
  'You are building a life that no longer needs escape.',
  'Healing requires repetition, and you are repeating the right things.',
  'Your identity is shaped by your persistence, not your setbacks.',
  'You are learning to choose peace over pressure.',
  'Courage is quiet, and you are practicing it.',
  'The healthiest version of you is under construction.',
  'You are making difficult choices for meaningful reasons.',
  'Keep the promise for today; tomorrow will thank you.',
  'Your consistency is becoming your confidence.',
  'You are one decision away from a better direction.',
  'Progress is not linear, but your commitment can be.',
  'You are stronger every time you pause and choose wisely.',
  'Progress is built from ordinary faithful actions.',
  'You are proving that your goals are bigger than your challenges.',
  'The effort you make today reduces the struggle of tomorrow.',
  'You are not defined by setbacks, only by your response.',
  'Each day you show up, your foundation gets stronger.',
  'You are turning intention into action, and action into change.',
  'Your present choices are writing your future testimony.',
  'You are capable of renewal, growth, and lasting wellness.',
  'The goal is not perfection, it is alignment.',
  'You are practicing freedom with every healthy boundary.',
  'What you repeat, you become—keep repeating what heals.',
  'You are training your mind to support your mission.',
  'The next right step always matters.',
  'You are allowed to move at the pace of sustainable change.',
  'Your discipline is an act of self-love.',
  'You are becoming more reliable to yourself every day.',
  'Healing accelerates when you keep showing up.',
  'Your effort is planting seeds you will soon live in.',
  'You are not too late; you are right on time for change.',
  'One intentional day can restart your momentum.',
  'You are stronger than the story fear tells.',
  'The version of you that keeps going is winning.',
  'You are building a stable life one steady choice at a time.',
  'Progress is quiet, but it is powerful.',
  'You are practicing the kind of consistency that transforms lives.',
  'Every mindful pause is a victory for your future.',
  'You are learning to lead yourself with wisdom.',
  'The work is real, and so is your growth.',
  'You are here, and that already matters.',
  'Your courage is visible in your commitment.',
  'You are becoming stronger where you used to feel fragile.',
  'Each healthy decision is a vote for the life you want.',
  'You are building momentum, not just motivation.',
  'Sustainable mental wellness is possible, and you are proving it today.',
  'You are growing beyond old patterns with every intentional step.',
  'The choice to show up is the choice to heal.',
  'You are making your future safer with today’s discipline.',
  'Keep your focus on the next faithful action.',
  'You are capable, prepared, and already in motion.',
  'Every day you show up, you move from surviving to rebuilding.',
  'You are becoming the person you needed when this journey began.',
  'Your resilience is stronger than the resistance you feel.',
  'You are creating a life that reflects your values.',
  'Today’s consistency is tomorrow’s confidence.',
  'You are worthy of wellness, and you are doing the work.',
  'The step in front of you is enough for this moment.',
  'You are showing your future self what commitment looks like.'
];

export const getRandomInspirationalQuote = () => {
  const index = Math.floor(Math.random() * INSPIRATIONAL_QUOTES.length);
  return INSPIRATIONAL_QUOTES[index];
};
